import SidebarBookingsInternalMessagesRoute from 'uplisting-frontend/pods/-sidebar/bookings/internal-messages/route';

export default class ProtectionOverviewBookingsInternalMessagesRoute extends SidebarBookingsInternalMessagesRoute {
  parentRoute = 'protection.overview.bookings';
}
